import React from 'react';
import '../styles/Pie.css';

const Pie = () => {
    return (
        <div className='piedepagina'>
            <p>Leonardo Larios | Mexicali, B.C. | 2022</p>
        </div>
    );
}
 
export default Pie;